<template>
    <section>
        <loading id="spinner" :active="loading" :can-cancel="false" :is-full-page="true"></loading>

        <div class="row">
            <div class="col s12">

                <ul id="tabs-configuracao-inscricao" class="tabs">
                    <li class="tab col s4"><a class="active" href="#itens">Itens</a></li>
                    <li class="tab col s4"><a href="#pdt">Plano de Trabalho</a></li>
                    <li class="tab col s4"><a href="#modalidades">Modalidades & Bolsas</a></li>
                </ul>
				<br>
                <div id="itens" class="col s12">
                    <div class="row">
                        <div class="col s12">
                            <fieldset>
                                <div class="row">
                                    <div class="col s12">
                                        <Itens :p-itens="configuracao.itens"
											:p-modalidades="configuracao.modalidades"
											:bloqueio="bloqueio" />
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div id="pdt" class="col s12">
                    <div class="row">
                        <div class="col s12">
                            <fieldset class="card-panel">
                                <div class="row">
                                    <div class="col s12">
                                        <Plano_de_trabalho :p-plano-trabalho="configuracao.plano_trabalho"
                                                           :p-justificativa-pdt-repetido.sync="configuracao.justificativa_pdt_repetido"
														   :p-modalidades="configuracao.modalidades"
														   :bloqueio="bloqueio"/>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>

                <div id="modalidades" class="col s12">
                    <div class="row">
                        <div class="col s12">
                            <fieldset class="card-panel">
                                <div class="row">
                                    <div class="col s12">
                                        <Modalidades :p-modalidades="configuracao.modalidades" :bloqueio="bloqueio"/>
                                    </div>
                                </div>
                            </fieldset>
                        </div>
                    </div>
                </div>


            </div>

        </div>
    </section>
</template>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Itens from "./itens";
import Modalidades from "./modalidades";
import Plano_de_trabalho from "./plano_de_trabalho";
export default {
    name: "configuracao_inscricao",
    components: {Plano_de_trabalho, Modalidades, Itens, Loading},
    provide: function () {
        return {
            principal: this
        }
    },
    props: {
        configuracaoPadrao: {
            type: String,
            default: null,
        },
		bloqueio: {
            type: String,
            default: null,
        }
    },
    data() {
        return {
            configuracao: {
                id: null,

                itens: [],

                plano_trabalho: [],

                modalidades: [],

                justificativa_pdt_repetido: null,
            },

            loading: false,
        }
    },
    mounted() {
        const configPadrao = this.configuracaoPadrao ? JSON.parse(this.configuracaoPadrao) : null

        if(configPadrao){
            this.configuracao.itens = configPadrao.itens
            this.configuracao.modalidades = configPadrao.modalidades
            this.configuracao.plano_trabalho = configPadrao.plano_trabalho
            this.configuracao.justificativa_pdt_repetido = configPadrao.justificativa_pdt_repetido
        }
    },
    methods: {
        inicializaTab(){
            $('#tabs-configuracao-inscricao').tabs();
        },

        async salva() {
            this.loading = true

            await this.$http.post('/api/configuracoes-inscricao', this.configuracao).then(response => {
                Swal.fire('Sucesso!', response.body.msg, 'success')
            }, error => {
                Swal.fire({ title: 'Ocorreu um erro!', text: error.body.msg, footer: error.body.exception, icon: 'error'})
            })

            this.loading = false
        }
    },
}
</script>

<style scoped>
</style>
